import { SET_SIGNUP_ATTEMPT, CLEAR_SIGNUP_STATUS, signUpStatusReasons, SET_SIGNUP_EMAIL, SET_SIGNUP_PROPERTIES, SET_SIGNUP_ACCOUNT } from "../actions/signUpActions"
import { requestState } from "../actions/utils";

const initialState = {
    status: requestState.none,
    reason: signUpStatusReasons.none,
    email: undefined,
    account: {},
    properties: []
}

export default function signUpReducer( state = initialState, action ) {
    switch ( action.type ) {
        case CLEAR_SIGNUP_STATUS:
            return {
                ...state,
                status: initialState.status,
                reason: initialState.reason,
                email: initialState.email,
                account: initialState.account,
                properties: initialState.properties
            }
        case SET_SIGNUP_ATTEMPT:
            return {
                ...state,
                status: action.status,
                reason: action.reason
            }
        case SET_SIGNUP_EMAIL:
            return {
                ...state,
                email: action.email
            }
        case SET_SIGNUP_ACCOUNT:
            return {
                ...state,
                account: action.account
            }
        case SET_SIGNUP_PROPERTIES:
            return {
                ...state,
                properties: action.properties
            }
        default: return state;
    }
}